import styled from 'styled-components'

export const Container = styled.div`
  background: transparent;

  @media (max-width: 1279px) {
    padding: 45px 70px 35px 90px;
    display: grid;
    background-color: #fff;
    border-radius: 10px;
    grid-template-rows: repeat(2, max-content);
    grid-template-columns: repeat(2, 1fr);
    row-gap: 25px;
    column-gap: 60px;

    & > div:nth-child(2) {
      order: 2;
    }

    & > div:nth-child(3) {
      order: 3;
    }
  }

  @media (max-width: 999px) {
    padding: 40px 60px 40px 30px;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    max-width: unset;
    padding: 40px 25px 40px 20px;
  }
`
